import { Component, ViewChild, ElementRef , HostListener, Inject } from '@angular/core';
import { projectConstants } from '../../../shared/constants/project-constants';
import { PaginationService } from 'src/app/services/pagination.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { UnverifiedAccountService } from 'src/app/services/unverified-account.service';
import { AccountService } from 'src/app/services/account.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-bookingstat-view',
  templateUrl: './bookingstat-view.component.html',
  styleUrls: ['./bookingstat-view.component.css']
})
export class BookingstatViewComponent {
  tableFilters = '';
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  selectedRowIndex = -1;
  showToolBar = false;
  collapsed;
  collapsedlcFilter;
  unverifyCount: any;
  Config: any = {};
  userTypes: any = [];
  screenHeight;
  screenWidth;
  salesChannelss;
  paymentDetais;
  showsaleschannel;
  small_device_display = false;
  salesfilter;
  accountTypes: any = [];
  salesChannelfilter;
  consumerCount: number;
  user: any;
  type: any;
  UnverifiedAccount: any;
  otpPurposes: any = [];
  acc_id: any = [];
  unverifyaccounts: any;
  unvrifynew: any;
  payvalue: any;
  values: any;
  statType;
  tokenData;
  paymentData;
  token_datetype;
  token_dateCategory;
  bookingon_checkin;
  bookingon_payment;
  showdonation_for_data: true;
  showcheckin_for_data: true;
  showappt_for_data : true;
  showpayment_for_data: true;
  bookingdate_checkin;
  bookingon_lastseven_checkin;
  apptData;
  donationData;
  bookingfor_lastseven_checkin;
  bookingfor_tomarrow_checkin;
  bookingon_tomarrow_checkin;
  bookingon_nextseven_checkin;
  bookingfor_nextseven_checkin;
  bookingon_appt;
  bookingdate_appt;
  bookingon_lastseven_payment;
  bookingon_tomarrow_payment;
  bookingon_nextseven_payment;
  bookingon_lastseven_appt;
  bookingfor_lastseven_appt;
  bookingon_nextseven_appt;
  bookingfor_nextseven_appt;
  bookingon_tomarrow_appt;
  bookingfor_tomarrow_appt;
  bookingon_donation;
  bookingon_lastseven_donation;
  bookingon_tommarow_donation;
  bookingon_nextseven_donation;
  token_lastBookingDate;
  value;
  domain = projectConstants.DOMAIN;
  subdomain = projectConstants.SUBDOMAIN;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountService: AccountService ) {
    }

  ngOnInit() {
    // console.log(this.data);
    if(this.data.statType === 'CHECKIN'){
      this.value = 'TOKEN';
      this.showcheckin_for_data = true;
      this.accountService.getStats(this.data.statType,this.data.accountId).subscribe(
        (data) => {
        //  console.log(data);
         this.tokenData  = data;
        //  console.log(this.tokenData);
         this.tokenData.checkin.forEach(token_details_sp => {
          this.tokenData.checkin = token_details_sp;
           this.token_datetype =this.tokenData.checkin.dateType;
           this.token_dateCategory =this.tokenData.checkin.dateCategory;
           this.token_lastBookingDate =this.tokenData.lastBookingDate;
           if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY'){
             this.bookingon_checkin = this.tokenData.checkin.stats;
           }
           if( this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'TODAY'){
             this.bookingdate_checkin = this.tokenData.checkin.stats;
           }
           if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS'){
             this.bookingon_lastseven_checkin = this.tokenData.checkin.stats;
           }
           if( this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'LAST_SEVEN_DAYS'){
             this.bookingfor_lastseven_checkin = this.tokenData.checkin.stats;
           }
           if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TOMORROW'){
            this.bookingon_tomarrow_checkin = this.tokenData.checkin.stats;
          }
          if( this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'TOMORROW'){
            this.bookingfor_tomarrow_checkin = this.tokenData.checkin.stats;
          }
          if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'NEXT_SEVEN_DAYS'){
            this.bookingon_nextseven_checkin = this.tokenData.checkin.stats;
          }
          if( this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'NEXT_SEVEN_DAYS'){
            this.bookingfor_nextseven_checkin = this.tokenData.checkin.stats;
          }
         });
        })
    }
    
    else if (this.data.statType === 'APPT'){
      this.value = 'APPOINTMENT';
      this.showappt_for_data = true;
      this.accountService.getStats(this.data.statType,this.data.accountId).subscribe(
        (data) => {
        //  console.log(data);
         this.apptData  = data;
        //  console.log(this.apptData);
         this.apptData.appt.forEach(appt_details_sp => {
          this.apptData.appt = appt_details_sp;
           this.token_datetype =this.apptData.appt.dateType;
           this.token_dateCategory =this.apptData.appt.dateCategory;
           this.token_lastBookingDate =this.apptData.lastBookingDate;
           if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY'){
             this.bookingon_appt = this.apptData.appt.stats;
           }
           if( this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'TODAY'){
             this.bookingdate_appt = this.apptData.appt.stats;
           }
           if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS'){
             this.bookingon_lastseven_appt = this.apptData.appt.stats;
           }
           if( this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'LAST_SEVEN_DAYS'){
             this.bookingfor_lastseven_appt = this.apptData.appt.stats;
           }
           if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TOMORROW'){
            this.bookingon_tomarrow_appt = this.apptData.appt.stats;
          }
          if( this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'TOMORROW'){
            this.bookingfor_tomarrow_appt = this.apptData.appt.stats;
          }
          if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'NEXT_SEVEN_DAYS'){
            this.bookingon_nextseven_appt = this.apptData.appt.stats;
          }
          if( this.token_datetype === 'BOOKING_SERVICE_DATE' && this.token_dateCategory === 'NEXT_SEVEN_DAYS'){
            this.bookingfor_nextseven_appt = this.apptData.appt.stats;
          }
         });
        })
    }
    else if (this.data.statType === 'DONATION'){
      this.value = 'DONATION';
      this.showdonation_for_data = true;
    this.accountService.getStats(this.data.statType,this.data.accountId).subscribe(
      (data) => {
        this.donationData  = data;
        this.donationData.donation.forEach(donation_details_sp => {
         this.donationData.donation = donation_details_sp;
          this.token_datetype =this.donationData.donation.dateType;
          this.token_dateCategory =this.donationData.donation.dateCategory;
          this.token_lastBookingDate =this.donationData.lastBookingDate;
          if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY'){
            this.bookingon_donation = this.donationData.donation.stats;
            // console.log(this.bookingon_donation);
          }
          if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS'){
            this.bookingon_lastseven_donation = this.donationData.donation.stats;
            // console.log(this.bookingon_lastseven_donation);
          }
          if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TOMORROW'){
            this.bookingon_tommarow_donation = this.donationData.donation.stats;
            // console.log(this.bookingon_lastseven_donation);
          }
          if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'NEXT_SEVEN_DAYS'){
            this.bookingon_nextseven_donation = this.donationData.donation.stats;
            // console.log(this.bookingon_lastseven_donation);
          }
        });
      }
     )
    }
    else if (this.data.statType === 'PREPAYMENT'){
      this.value = 'PREPAYMENT';
      this.showpayment_for_data = true;
      this.accountService.getStats(this.data.statType,this.data.accountId).subscribe(
        (data) => {
          this.paymentData  = data;
          // console.log(this.paymentData);
          this.paymentData.prepayment.forEach(payment_details_sp => {
           this.paymentData.prepayment = payment_details_sp;
            // console.log(this.paymentData.prepayment);
            this.token_datetype =this.paymentData.prepayment.dateType;
            this.token_dateCategory =this.paymentData.prepayment.dateCategory;
            this.token_lastBookingDate =this.paymentData.lastBookingDate;
            // console.log(this.token_datetype);
            // console.log(this.token_dateCategory);
            if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TODAY'){
              this.bookingon_payment = this.paymentData.prepayment.stats;
              // console.log(this.bookingon_payment);
            }
            if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'LAST_SEVEN_DAYS'){
              this.bookingon_lastseven_payment = this.paymentData.prepayment.stats;
              // console.log(this.bookingon_lastseven_payment);
            }
            if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'TOMORROW'){
              this.bookingon_tomarrow_payment = this.paymentData.prepayment.stats;
              // console.log(this.bookingon_lastseven_payment);
            }
            if( this.token_datetype === 'BOOKING_ON' && this.token_dateCategory === 'NEXT_SEVEN_DAYS'){
              this.bookingon_nextseven_payment = this.paymentData.prepayment.stats;
              // console.log(this.bookingon_lastseven_payment);
            }
          });
        }
       )
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
 
  
  onRowClicked(UnverifiedAccount) {
    this.selectedRowIndex = UnverifiedAccount.loginId;
    this.showToolBar = !this.showToolBar;
  }
  showview(){

  }

}
